import { render } from "./Halfcutservices.vue?vue&type=template&id=258e8fe4&scoped=true"
import script from "./Halfcutservices.vue?vue&type=script&lang=js"
export * from "./Halfcutservices.vue?vue&type=script&lang=js"

import "./Halfcutservices.vue?vue&type=style&index=0&id=258e8fe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258e8fe4"]])

export default __exports__